import Vue from 'vue';
import VueResource from 'vue-resource';
import services from './services';
import _ from 'lodash';

Vue.use(VueResource);

const http = Vue.http

http.options.root = process.env.VUE_APP_BFF_URL;

// Configura timeout global para todas as requisições (30 segundos)
http.options.timeout = 30000;

Object.keys(services).map(service => {
  services[service] = Vue.resource('',{}, services[service])
})

// Interceptor para adicionar Authorization header
http.interceptors.push((request) => {
  if (_.isNull(request.headers.get("Authorization")) && $cookies.get("token_user")) {
    request.headers.set("Authorization", `Bearer ${$cookies.get("token_user")}`)
  }   
})

// Interceptor para tratar erros de timeout e converter em Error objects
http.interceptors.push((request, next) => {
  next(
    (response) => {
      // Se a resposta não for ok
      if (!response.ok) {
        // Trata timeout (status 0 ou 408)
        if (response.status === 0 || response.status === 408 || response.statusText === 'Timeout') {
          const timeoutError = new Error('Tempo limite de conexão excedido. Por favor, tente novamente.');
          timeoutError.status = response.status;
          timeoutError.statusText = 'Timeout';
          return Promise.reject(timeoutError);
        }
      }
    },
    (error) => {
      // Trata rejeições diretas (quando não há resposta, como em timeouts)
      // O vue-resource pode rejeitar com a string "Timeout" diretamente
      if (error === 'Timeout' || 
          (typeof error === 'string' && error.toLowerCase().includes('timeout')) ||
          (error && error.statusText === 'Timeout')) {
        const timeoutError = new Error('Tempo limite de conexão excedido. Por favor, tente novamente.');
        timeoutError.status = 0;
        timeoutError.statusText = 'Timeout';
        return Promise.reject(timeoutError);
      }
      // Se for um objeto Error, retorna como está
      if (error instanceof Error) {
        return Promise.reject(error);
      }
      // Se for uma string ou outro tipo, converte em Error
      if (typeof error === 'string') {
        return Promise.reject(new Error(error));
      }
      // Para outros tipos, cria um Error genérico
      return Promise.reject(new Error('Ocorreu um erro na requisição'));
    }
  );
})

export { http }
export default services;